export enum FormSectionValidationMode {
  Submit = 1,
  Page = 2,
}